

let isDev = false
let Gprefix = ''
let Gtype = 'web'
let GRoot = ''
let GV = 'v1' // 全局ajax接口的版本控制，值为'v1' or 'v2'
let GRegTel = /^1[3-9]\d{9}$/
let currhost = window.location.host
let testHosts = ['127.0.0.1:8080', 'test.qingyin.net']
if (testHosts.indexOf(currhost) > -1) {
  isDev = true
}
if (isDev) {
	Gprefix = 'https://better.test.qingyin.net/server/better/api'
} else {
	Gprefix = 'https://better.qingyin.net/server/better/api'
}
GRoot = 'http://' + window.location.host + '/'
//判断当前设备是否为移动端
function isMobileDevice() {
	let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
	return flag
}

// 一行n个数据
function listModel (list, n) {
	let index = 0
	let count = n
	let arrTemp = []
	let experts = list
	for (let i = 0; i < list.length; i++) {
		index = parseInt(i / count)
		if (arrTemp.length <= index) {
		arrTemp.push([])
		}
		arrTemp[index].push(experts[i])
	}
	return arrTemp
}
// 接口路径
function URLProxy (uri, vFlag) {
  // 有版本号
  if (vFlag) {
	uri = GV + '/' + uri
  }
  var url = Gprefix + '/' + Gtype + '/' + uri
  return url
}        
// 处理时间格式
function dataFormat (value, fmt) {
	let getDate = new Date(value.replace(/-/g, '/'))
	// let getDate = new Date(value)
	let o = {
	  'M+': getDate.getMonth() + 1,
	  'd+': getDate.getDate(),
	  'h+': getDate.getHours(),
	  'm+': getDate.getMinutes(),
	  's+': getDate.getSeconds(),
	  'q+': Math.floor((getDate.getMonth() + 3) / 3),
	  'S': getDate.getMilliseconds()
	}
	if (/(y+)/.test(fmt)) {
	  fmt = fmt.replace(RegExp.$1, (getDate.getFullYear() + '').substr(4 - RegExp.$1.length))
	}
	for (let k in o) {
	  if (new RegExp('(' + k + ')').test(fmt)) {
		fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
	  }
	}
	return fmt
  }
export default {
	Gprefix,
	GRegTel,
    isMobileDevice,
    listModel,
	URLProxy,
	dataFormat
}


// WEBPACK FOOTER //
// ./src/assets/js/common.js